import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

/** Old History URL — send people to Past. */
export default class CoachingCoachSessionsHistoryRoute extends Route {
  @service declare router: RouterService;

  beforeModel(): void {
    this.router.replaceWith('coaching.coach.sessions.past');
  }
}
